import axiosServices from "../utils/axios";

export const fetchKnowledgeBaseList = async () => {
  try {
    const response = await axiosServices.get(`/knowledgeBase`);
    return response?.data?.data;
  } catch (error: any) {
    throw new Error(
      error?.data?.message || "Failed to fetch knowledge base"
    );
  }
};

export const updateKnowledgeBase = async (
  id: string,
  data: {
    [key: string]: any;
    id: string;
  }
) => {
  try {
    const response = await axiosServices.put(
      `/knowledgeBase/${id}`,
      data
    );
    return response?.data?.data;
  } catch (error: any) {
    console.error("Error updating knowledge base:", error?.message || error);
    throw new Error(
      error?.response?.data?.message || "Failed to update knowledge base"
    );
  }
};

export const deleteKnowledgeBase = async (id: string) => {
  try {
    const response = await axiosServices.delete(
      `/knowledgeBase/${id}`
    );
    return { success: response?.data?.success, id };
  } catch (error: any) {
    throw new Error(error?.data?.message || "Failed to delete the data");
  }
};

export const addKnowledgeBase = async (data: { [key: string]: any }) => {
  try {
    const response = await axiosServices.post(`/knowledgeBase`, data);
    return response.data.data;
  } catch (error: any) {
    throw new Error(
      error?.data?.message || "Failed to add the new knowledge base item"
    );
  }
};
